@if (loading()) {
  <se-fe-spinner [seFeDataSize]="900" [seFeDataCenter]="true"></se-fe-spinner>
}
<div>
  @if (showSearch() && (!hideSearchWhenEmpty() || !isZeroState())) {
    <se-fe-toolbar
      class="product-table-toolbar"
      [seFeDataQuery]="query() || ''"
      (seFeQueryChange)="handleSearch($event)"></se-fe-toolbar>
  }
  @if (products() && products()!.length > 0 && datasource()) {
    <div [formGroup]="form">
      <se-fe-table-wrapper class="product-list-table-wrapper">
        <table
          seFeTable
          [seFeTableSort]="initialSort()"
          title="Product selection table"
          style="max-height: 400px"
          class="product-list-table"
          [dataSource]="datasource()"
          (seFeSortChange)="sortChange($event)">
          <ng-container seFeColumnDef="Select">
            <th seFeHeaderCell *seFeHeaderCellDef>
              <se-fe-checkbox formControlName="selectAll" [seFeDataOptions]="selectAllOptions"></se-fe-checkbox>
            </th>
            <td seFeCell *seFeCellDef="let row">
              <se-fe-checkbox
                [formControlName]="getRowId(row)"
                [seFeDataOptions]="rowSelectionOptions"></se-fe-checkbox>
            </td>
          </ng-container>
          <ng-container seFeColumnDef="Name">
            <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="name" seFeTableSortHeader>
              Product Name
            </th>
            <td class="table-row" seFeCell *seFeCellDef="let row">
              <product-name-cell [product]="row"></product-name-cell>
            </td>
          </ng-container>
          <ng-container seFeColumnDef="Active">
            <th class="table-header" seFeHeaderCell *seFeHeaderCellDef seFeDataRef="active" seFeTableSortHeader>
              Status
            </th>
            <td class="statusColumn" seFeCell *seFeCellDef="let row">
              <product-status-cell [product]="row"></product-status-cell>
            </td>
          </ng-container>
          <tr seFeHeaderRow *seFeHeaderRowDef="displayedColumns"></tr>
          <tr [seFeRow]="row" *seFeRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </se-fe-table-wrapper>
    </div>
  } @else {
    <se-fe-empty-state class="empty-state" seFeDataTitle="No products found"></se-fe-empty-state>
  }
  @if (products()?.length && paginationEnabled()) {
    <se-fe-pagination
      [seFeDataPaginationOptions]="paginationOptions()"
      (seFePaginationChange)="paginationChange($event)"></se-fe-pagination>
  }
</div>
